import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ErrorBoundary } from 'react-error-boundary';
import { useEffect, useMemo } from 'react';
import Cookie from 'js-cookie';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';

import { setPolicyRoute } from './store/slices/generalSlice';
import { RootState } from './store/rootReducer';
import storageService from './services/storage.service';
import MobilityRoutes from './navigation/MobilityRoutes';
import ResetStyles from './global-styles/reset';
import { Fonts } from './global-styles/fonts';
import Splashes from './containers/public/splashes/splashes';
import InvalidData from './containers/public/invalid-data/InvalidData';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { RECAPTCHA_KEY } from './constants/env';
import { ASITUR_CODE, INSURANCE_COMPANIES } from './constants';
import Toast from './components/toast/Toast';
import NavigationHandler from './components/navigation-handler/navigation-handler';
import ModalPolicy, { PolicyRouteType } from './components/modals/policy/ModalPolicy';
import ManageCookies, { Cookies } from './components/modal-cookies/ModalCookies';
import Loader from './components/loader/MainLoader';
import BrandHeader from './components/brand-header/BrandHeader';

function App() {
  const dispatch = useDispatch();
  const splashLoaded = useSelector((state: RootState) => state.general.splashLoaded);
  const { policyRoute } = useSelector((state: RootState) => state.general);
  const providerCodeState = useSelector((state: RootState) => state.general.provider);
  const providerCodeStorage = storageService.getLocalItem<string>('providerCode');

  const initialTheme = useMemo(() => {
    if (providerCodeState) {
      return INSURANCE_COMPANIES[providerCodeState as keyof typeof INSURANCE_COMPANIES].theme;
    } else if (providerCodeStorage) {
      return INSURANCE_COMPANIES[providerCodeStorage].theme;
    } else {
      return INSURANCE_COMPANIES[ASITUR_CODE].theme;
    }
  }, [providerCodeState, providerCodeStorage]);

  useEffect(() => {
    const cookieConfig = Cookie.get('cookie-config');
    if (!cookieConfig) {
      return;
    }
    const _cookiesParsed: Cookies | undefined = JSON.parse(cookieConfig);
    // manage if accepted or not
  }, []);

  const handlePolicyModal = (route: PolicyRouteType | undefined) => {
    dispatch(setPolicyRoute({ policy: route }));
  };

  return (
    // <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY} useEnterprise={true} language="es">
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={initialTheme}>
        <ReactQueryDevtools initialIsOpen={false} />
        <ResetStyles />
        <Fonts />
        <Loader />
        {!splashLoaded && <Splashes />}
        <main>
          <BrandHeader />
          <Router>
            <NavigationHandler>
              <ErrorBoundary FallbackComponent={InvalidData}>
                <MobilityRoutes />
              </ErrorBoundary>
            </NavigationHandler>
          </Router>
        </main>
        <Toast />
        <ManageCookies />
        <ModalPolicy active={!!policyRoute} onClose={() => handlePolicyModal(undefined)} route={policyRoute} />
      </ThemeProvider>
    </LocalizationProvider>
    // </GoogleReCaptchaProvider>
  );
}

export default App;
